import { CouponInCampain, CouponWithUsages } from '../../types/coupon';

export const getIsActive = (coupon: CouponInCampain | CouponWithUsages): boolean => {
  return Boolean(coupon?.active);
};

export const getCouponName = (coupon: CouponInCampain | CouponWithUsages): string => {
  return coupon.name || 'Unknown coupon';
};

export const getCouponValue = (coupon: CouponInCampain | CouponWithUsages): string => {
  return coupon.code || 'Unknown coupon';
};

export const getCouponId = (coupon: CouponInCampain | CouponWithUsages): string => {
  return coupon.uuid || 'not uuid';
};

export const isNumber = (variable: number | null | undefined): variable is number => {
  if (variable === undefined || variable === null) {
    return false;
  }

  return !isNaN(variable);
};

export const getIsReachLimit = (coupon: CouponWithUsages): boolean => {
  const { limit, limitPerDay, usages, usagesPerDay } = coupon;

  let overLimitByDay = false;
  let overlimit = false;

  if (isNumber(limit) && isNumber(usages)) {
    overlimit = usages >= limit;
  }

  if (isNumber(limitPerDay) && isNumber(usagesPerDay)) {
    overLimitByDay = usagesPerDay >= limitPerDay;
  }

  return overLimitByDay || overlimit;
};
